import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';
import { CreditResponse } from './types';

export const creditBalanceApi = createApi({
  reducerPath: 'creditBalanceApi',
  baseQuery,
  tagTypes: ['CreditBalance', 'Transactions'],
  endpoints: builder => ({
    getMessagingStats: builder.query<CreditResponse, void>({
      query: () => '/messaging/stats',
      providesTags: ['CreditBalance'],
    }),
    purchaseCredits: builder.mutation({
      query: data => ({
        url: '/messaging/credit/purchase',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['CreditBalance', 'Transactions'],
    }),
  }),
});

export const { useGetMessagingStatsQuery, usePurchaseCreditsMutation } =
  creditBalanceApi;
